import gql from 'graphql-tag';

export const getAiring = gql`
	query getAiring($id: ID!) {
		getAiring(id: $id) {
			businessLogic
			channelId
			id
			alternateIds {
				items {
					id
					alternateId
					namespace
				}
			}
			game {
				id
				startTime
				sport
				title
				teams {
					items {
						id
						name
						abbreviation
						logoUrl
					}
				}
				airings {
					items {
						id
						startTime
						channel {
							id
							name
							territory
							sourceAssets {
								items {
									id
									url
									format
								}
							}
						}
					}
				}
			}
			editorialHighlight {
				id
				periods {
					items {
						playId
						startPosition
						endPosition
						startGameTime {
							segmentId
							segment
							position
						}
						gameEndTime {
							segmentId
							position
						}
						source {
							type
							startTime
							endTime
							channelId
						}
						endScore
						title
						shortText
						description
						type
						team {
							id
						}
					}
				}
			}
			highlights(sortDirection: DESC) {
				items {
					id
					available
					availableTime
					type
					publishTime
					videoAssets {
						items {
							format
							url
						}
					}
					gameId
					game {
						title
					}
					periods {
						items {
							startPosition
							endPosition
							startGameTime {
								segment
								position
							}
							source {
								type
								channelId
								startTime
								endTime
								gameId
							}
							teamId
							team {
								id
								name
								abbreviation
								logoUrl
							}
							title
							type
							shortText
							description
						}
					}
				}
			}
			startTime
			status
			channel {
				id
				name
				territory
				type
				sourceAssets {
					items {
						id
						url
						format
					}
				}
			}
			offsets {
				items {
					segment
					offset
				}
			}
			clientExclusions
			programSynopsis
			programStartTime
			programEndTime
			drm
			sources {
				url
				drmProvider
				contentRef
				configAlias
				propositionContentId
				protection
				transport
				providerVariantId
			}
		}
	}
`;

export const getAiringHighlights = gql`
	query getAiring($id: ID!, $limit: Int, $nextToken: String, $available: Boolean, $publishTime: String, $filter: HighlightFilterInput) {
		getAiring(id: $id) {
			id
			highlights(sortDirection: DESC, limit: $limit, nextToken: $nextToken, available: $available, publishTime: $publishTime, filter: $filter) {
				items {
					id
					available
					availableTime
					type
					periods {
						items {
							title
						}
					}
					publishTime
				}
				nextToken
			}
		}
	}
`;

export const getLatestHighlight = gql`
	query getLatestHighlight($airingId: ID, $gameId: ID, $type: String, $available: Boolean) {
		getLatestHighlight(airingId: $airingId, gameId: $gameId, type: $type, available: $available) {
			id
			available
			availableTime
			type
			publishTime
			videoAssets {
				items {
					format
					url
				}
			}
			gameId
			game {
				id
				title
			}
			periods {
				items {
					id
					playId
					startPosition
					endPosition
					endpoint
					endScore
					shortText
					source {
						type
						channelId
						startTime
						endTime
						gameId
					}
					startGameTime {
						segment
						segmentId
						position
					}
					title
					type
					description
					team {
						id
						name
						logoUrl
					}
				}
			}
		}
	}
`;

export const listAirings = gql`
	query ListAirings($nextToken: String, $limit: Int, $channelId: String, $sortDirection: SortDirection, $filter: ListAiringsFilterInput) {
		listAirings(nextToken: $nextToken, limit: $limit, channelId: $channelId, sortDirection: $sortDirection, filter: $filter) {
			items {
				status
				id
				channelId
				startTime
				businessLogic
				highlights {
					items {
						id
					}
				}
				game {
					id
					title
				}
			}
		}
	}
`;
